import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-primitives.svg
 */
const IconTypePrimitives: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M7.059 8.415l.708-.26-1.79-3.835a.374.374 0 00-.357-.218.371.371 0 00-.142.037.363.363 0 00-.182.181L.033 15.597a.38.38 0 00.342.535H5.27v-.752H1.478a.319.319 0 01-.288-.457l4.458-9.555 1.41 3.047zM18.606 4.853a5.472 5.472 0 00-4.57 2.487l.729.266a4.701 4.701 0 017.293-.495 4.634 4.634 0 011.198 3.927 4.713 4.713 0 01-4.463 3.96v.751a5.452 5.452 0 00-.187-10.896z"
      fill="currentColor"
    />
    <path
      d="M17.298 9.32l-4.895-1.767a1.095 1.095 0 00-.769 0L6.739 9.321a1.13 1.13 0 00-.743 1.063v6.335a1.126 1.126 0 00.691 1.039l4.896 2.053a1.117 1.117 0 00.863 0l4.896-2.053a1.125 1.125 0 00.69-1.039v-6.336a1.13 1.13 0 00-.734-1.062zM11.9 8.26h.257l4.682 1.696-4.835 1.825-4.789-1.823L11.9 8.26zm-4.895 8.796a.372.372 0 01-.23-.345v-6.118l4.895 1.86v6.559l-4.665-1.956zm10.064 0l-4.656 1.959v-6.58l4.895-1.847v6.123a.368.368 0 01-.239.345z"
      fill="currentColor"
    />
  </svg>
);

export default IconTypePrimitives;
